import * as moment from "moment";

export class Gruppo {
  public static GRUPPO_AMMINISTRATORE = "admin";
  public static GRUPPO_VENDOR_ADMIN = "vendor_admin";
  public static GRUPPO_GESTORE = "gestori";
  public static GRUPPO_COMMESSO = "commessi";
}

export class Sesso {
   public static m = "Maschio";
   public static f = "Femmina";
   public static nd = "Altro";

   public static getSesso(s){
      return Sesso[s];
   }
}


export class UserProfileData{
   public id?:number;
   public data_nascita?:string;
   public codice_fiscale?:string;
   public sesso?:string;
   public cellulare?:string;
   public cellulare_prefix?:string;
   public indirizzo_nascita?:any;
   public indirizzo_residenza?:any;
   public indirizzo_domicilio?:any;
   public sesso_display?:string = "";
   public data_nascita_display?:string = "";
   public email_convalidata?:boolean = false;
   public customer_ext_id?:string;
}


export class UserProfile {
   public data: UserProfileData = {}
   constructor(data:UserProfileData | any = {}) {
      if(!data) data = {}
      Object.assign(this.data, data);
      if (this.data?.sesso) this.data.sesso_display = Sesso[this.data?.sesso];
      if (this.data?.data_nascita) this.data.data_nascita_display = moment(this.data?.data_nascita).format('L');
   }
}
